import TransferOrderCreateController from './../controllers/transferorder.create.controller';

const TransferOrderCreateComponent = {
	templateUrl: 'components/transportauftrag/views/transferorder.create.html',
	controller: TransferOrderCreateController,
	bindings: {
		$router: '<'
	}
};

export default TransferOrderCreateComponent;
